import { render, staticRenderFns } from "./popReaders.vue?vue&type=template&id=10f848c2"
import script from "./popReaders.vue?vue&type=script&lang=js"
export * from "./popReaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports